import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import Inputs from '../../../../../../components/mui/Inputs';
import { getArrayListToDropdown } from '../services';
import { setIsLoadingForm, setArrayListToDropdown } from '../redux/actions/commercialStatusAction';
import usePermission from '../../../../../../hooks/usePermission';
import swalErrors from '../../../../../../hooks/useErrors';

const DropdownSelect = ({ realState = '', name, value = '', handleChange, ...more }) => {
	const dispatch = useDispatch();
	const isLoading = useSelector( ({ commercialStatus }) => commercialStatus.isLoadingForm);
	const arrayListToDropdown = useSelector( ({ commercialStatus }) => commercialStatus.arrayListToDropdown);
	const permission = usePermission('commercialStatus.dropdownByRealState');
	
	/**
	 *
	 * @description Execute endpoint array list keys in dropdown
	 * @return dispatch
	 *
	 */
	const handleArrayList = async () => {
		if (permission && realState !== '') {
			dispatch( setIsLoadingForm(true) );
			
			try {
				const { data } = await getArrayListToDropdown(realState);
				
				if (data.status === 200) {
					await dispatch( setArrayListToDropdown(data.data.records) );
				}
			} catch (error) {
				// await swalErrors(error);
			}
			
			dispatch( setIsLoadingForm(false) );
		} else {
			dispatch( setArrayListToDropdown([]) );
		}
	};
	
	useEffect(() => {
		handleArrayList();
	}, [realState]);
	
	return (
		<>
			{permission && !isLoading && (
				<Inputs.Select
					label="Estatus comercial"
					name={name}
					value={value}
					itemsArray={arrayListToDropdown}
					onChange={handleChange}
					className="animated__animated animated__fadeIn"
					{...more}
				/>
			)}
		</>
	);
};

DropdownSelect.propTypes = {
	realState: PropTypes.any.isRequired,
	name: PropTypes.string.isRequired,
	value: PropTypes.any,
	handleChange: PropTypes.func.isRequired
};

export default DropdownSelect;
